/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PaymentChangeSubscriptionPaymentMethodInput = {|
  corpoRef: string,
  paymentType: string,
  setupIntentId: string,
  retry?: ?boolean,
|};
export type PaymentCorpoChangeCardMutationVariables = {|
  input: PaymentChangeSubscriptionPaymentMethodInput
|};
export type PaymentCorpoChangeCardMutationResponse = {|
  +payment: ?{|
    +corpo: ?{|
      +res: ?{|
        +code: number,
        +message: string,
        +data: ?any,
      |}
    |}
  |}
|};
export type PaymentCorpoChangeCardMutation = {|
  variables: PaymentCorpoChangeCardMutationVariables,
  response: PaymentCorpoChangeCardMutationResponse,
|};
*/


/*
mutation PaymentCorpoChangeCardMutation(
  $input: PaymentChangeSubscriptionPaymentMethodInput!
) {
  payment {
    corpo {
      res: changeSubscriptionPaymentMethod(input: $input) {
        code
        message
        data
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PaymentMutation",
    "kind": "LinkedField",
    "name": "payment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentCorpoMutation",
        "kind": "LinkedField",
        "name": "corpo",
        "plural": false,
        "selections": [
          {
            "alias": "res",
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "PaymentPaymentPayload",
            "kind": "LinkedField",
            "name": "changeSubscriptionPaymentMethod",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "data",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentCorpoChangeCardMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaymentCorpoChangeCardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dc313e2844901e7363bf3a0eb90a3fd2",
    "id": null,
    "metadata": {},
    "name": "PaymentCorpoChangeCardMutation",
    "operationKind": "mutation",
    "text": "mutation PaymentCorpoChangeCardMutation(\n  $input: PaymentChangeSubscriptionPaymentMethodInput!\n) {\n  payment {\n    corpo {\n      res: changeSubscriptionPaymentMethod(input: $input) {\n        code\n        message\n        data\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e66bb64d3bd052d5d084b2b58d7efeeb';

module.exports = node;
